import { PackageKnowledge } from "./packageRegistry.js";

/**
 * Compiles contextual recommended next steps depending on the package configuration.
 */
export function generateRecommendations(packageName: string, knowledge: PackageKnowledge | null): string[] {
  const recommendations: string[] = [];
  const cleanName = packageName.toLowerCase();

  if (knowledge) {
    if (cleanName.includes("firebase")) {
      recommendations.push("Add google-services.json in your android/app/ folder.");
      recommendations.push("Add GoogleService-Info.plist inside your Xcode project root.");
    } else if (cleanName.includes("maps")) {
      recommendations.push("Add Google Maps API key inside your android/AndroidManifest.xml.");
      recommendations.push("Add Google Maps SDK GMSServices API Key inside ios/AppDelegate.");
    } else if (cleanName.includes("reanimated")) {
      recommendations.push("Verify 'react-native-reanimated/plugin' is added to babel.config.js plugins list.");
      recommendations.push("Run 'npm start -- --reset-cache' (or yarn/pnpm equivalent) to clear Metro bundler caches.");
    } else if (cleanName.includes("vision-camera")) {
      recommendations.push("Add NSCameraUsageDescription and NSMicrophoneUsageDescription keys inside Info.plist.");
      recommendations.push("Add camera permissions under AndroidManifest.xml.");
    }
  }

  recommendations.push("Run 'kyro doctor' or 'kyro explain' to verify project configuration health.");
  return recommendations;
}
